import React from "react"

export default function SelectColumnFilterSucceeded({ column: { filterValue, setFilter } }) {
  return (
    <select
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined)
      }}
    >
      <option value="">All</option>
      <option value="1">Succeeded</option>
      <option value="0">Failed</option>
    </select>
  )
}
